// рейтинг може приходити в 10 або 100 бальній системі, нормалізуємо до потрібного виду (одне число після коми)
export const normalizeRating = hotelRating => {
	if (hotelRating == null || isNaN(hotelRating)) return null

	const rating = Number(hotelRating)

	const normalized = rating > 10 ? rating / 10 : rating

	return parseFloat(normalized.toFixed(1))
}

export const getPhraseStringFromRating = rating => {
	if (rating > 8.5) {
		return 'Excellent'
	} else if (rating > 7.4) {
		return 'Very good'
	} else {
		return 'Good'
	}
}
